import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';
import { COLOR } from 'assets/styles/colors';
import BREAKPOINT from 'assets/styles/breakpoints';

export const StyledDialog = withStyles((theme) => ({
  paper: {
    margin: 18,
    background: 'transparent',
    boxShadow: 'none',
  },
  paperWidthSm: {
    width: '100%',
    maxWidth: 700,
    [theme.breakpoints.down('md')]: {
      width: '90vw',
      // height: 'calc(61vw / 1.77)',
    },
  },
  paperScrollPaper: {
    flexDirection: 'row',
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
}))(Dialog);

export const Content = styled.section`
  position: relative;
  width: 100%;
  min-height: 320px;
  text-align: right;

  button {
    font-size: 1.4rem;
    color: ${COLOR.GREEN_3};

    &:hover {
      color: ${COLOR.WHITE_1};
    }
  }

  iframe {
    display: block;
    width: 700px;
    max-width: 100%;
    //aspect ratio
    height: calc(700px / 1.77);

    @media screen and (max-width: ${BREAKPOINT.MD}) {
      width: 90vw;
      //aspect ratio
      height: calc(90vw / 1.77);
    }
  }

`;
